"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Skeleton: function() {
        return _index.Skeleton;
    },
    renderSkeleton_unstable: function() {
        return _index.renderSkeleton_unstable;
    },
    skeletonClassNames: function() {
        return _index.skeletonClassNames;
    },
    useSkeletonContextValues: function() {
        return _index.useSkeletonContextValues;
    },
    useSkeletonStyles_unstable: function() {
        return _index.useSkeletonStyles_unstable;
    },
    useSkeleton_unstable: function() {
        return _index.useSkeleton_unstable;
    }
});
const _index = require("./components/Skeleton/index");
